import React, { Component } from "react";
import { connect } from "react-redux";
import {
  saveDashboardStateToCache,
  restoreDashboardStateFromCache
} from "Actions";
import { fetchInfiniteDashboards } from "Thunks";

import DashboardComponent from "./DashboardComponent";

class DashboardContainer extends Component {
  componentDidMount() {
    const { offset, limit, fetchInfiniteDashboards } = this.props;
    fetchInfiniteDashboards({ limit, offset });
  }

  componentDidUpdate(prevProps) {
    const {
      limit,
      selectedClient,
      saveDashboardStateToCache,
      restoreDashboardStateFromCache,
      fetchInfiniteDashboards
    } = this.props;

    if (prevProps.selectedClient !== this.props.selectedClient) {
      if (selectedClient) {
        saveDashboardStateToCache();
        fetchInfiniteDashboards({
          limit,
          offset: 0,
          clientUEN: selectedClient.uen
        });
      } else {
        restoreDashboardStateFromCache();
      }
    }
  }

  loadMore = () => {
    const {
      offset,
      limit,
      selectedClient,
      fetchInfiniteDashboards
    } = this.props;

    const clientUEN = selectedClient && selectedClient.uen;
    fetchInfiniteDashboards({ limit, offset, clientUEN });
  };

  render() {
    const { dashboards, fetching, community, hasMore } = this.props;
    return (
      <DashboardComponent
        dashboards={dashboards}
        community={community}
        fetching={fetching}
        loadMore={this.loadMore}
        hasMore={hasMore}
      />
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  dashboards: state.dashboards.items,
  fetching: state.dashboards.fetching,
  selectedClient: state.dashboards.dashboardSelectedOrg,
  hasMore: state.dashboards.hasMoreItems,
  offset: state.dashboards.offset,
  limit: state.dashboards.limit
});

const mapDispatchToProps = dispatch => ({
  fetchInfiniteDashboards: params => dispatch(fetchInfiniteDashboards(params)),
  saveDashboardStateToCache: () => dispatch(saveDashboardStateToCache()),
  restoreDashboardStateFromCache: () =>
    dispatch(restoreDashboardStateFromCache())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardContainer);



// WEBPACK FOOTER //
// ./src/components/Community/WorkPlace/Dashboard/DashboardContainer.js